import { useState } from "react";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { Header } from "@/components/landing/Header";
import { Hero } from "@/components/landing/Hero";
import { Packages } from "@/components/landing/Packages";
import { Sprint } from "@/components/landing/Sprint";
import { Process } from "@/components/landing/Process";
import { WhyUs } from "@/components/landing/WhyUs";
import { TrustedBy } from "@/components/landing/TrustedBy";
import { Faq } from "@/components/landing/Faq";
import { FinalCta } from "@/components/landing/FinalCta";
import { LeadModal } from "@/components/landing/LeadModal";

function App() {
  const [modalOpen, setModalOpen] = useState(false);
  const [interest, setInterest] = useState("Free Audit + Sample Reel");

  const openModal = (preset = "Free Audit + Sample Reel") => {
    setInterest(preset);
    setModalOpen(true);
  };

  return (
    <div id="top" className="min-h-screen bg-[#0b1426] text-white antialiased">
      <Header onAudit={() => openModal()} />
      <main>
        <Hero onAudit={() => openModal()} />
        <Packages onChoose={(tier) => openModal(`${tier} Package`)} />
        <Sprint onClaim={() => openModal("Creative Sprint")} />
        <Process />
        <WhyUs />
        <TrustedBy />
        <Faq />
        <FinalCta onAudit={() => openModal()} />
      </main>
      <LeadModal
        open={modalOpen}
        onOpenChange={setModalOpen}
        interest={interest}
        onInterestChange={setInterest}
      />
      <Toaster theme="dark" position="top-center" richColors />
    </div>
  );
}

export default App;
